function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 62,
  fill: "transparent"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.8923 -6.91914C39.0607 -8.07266 40.9393 -8.07266 42.1077 -6.91915L78.1002 28.6151C80.0087 30.4994 78.6745 33.75 75.9925 33.75H4.0075C1.32551 33.75 -0.00875231 30.4994 1.89981 28.6151L37.8923 -6.91914Z",
  fill: "#F2E401"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.409 68.6691C41.2406 69.8227 39.362 69.8227 38.1936 68.6691L2.20109 33.1349C0.292523 31.2506 1.62678 28 4.30877 28H7.82532H18.6506H29.476H40.3013H51.1266L61.9519 28H72.7772H76.2938C78.9758 28 80.31 31.2506 78.4015 33.1349L42.409 68.6691Z",
  fill: "#F2E401"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 40,
  cy: 31,
  rx: 39,
  ry: 4,
  fill: "#1A1A1A"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 62,
  fill: "white"
})));

var SvgBead = function SvgBead(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 80 62",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBead, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bead.2eeaf0b7.svg";
export { ForwardRef as ReactComponent };